import { useEffect, useRef, useState } from "react";
import { Send } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";

export const ChatPanel = ({ messages, onSend }) => {
  const [text, setText] = useState("");
  const endRef = useRef(null);
  useEffect(() => endRef.current?.scrollIntoView({ behavior: "smooth" }), [messages]);

  const submit = (e) => {
    e.preventDefault();
    if (!text.trim()) return;
    onSend(text.trim());
    setText("");
  };

  return (
    <aside className="w-80 flex-shrink-0 border-l border-slate-800 bg-[#0B1120] flex flex-col" data-testid="chat-panel">
      <div className="px-4 h-12 flex items-center border-b border-slate-800">
        <p className="font-mono text-[11px] tracking-widest text-slate-400">CHAT AVEC L'UTILISATEUR</p>
      </div>
      <div className="flex-1 overflow-y-auto p-4 space-y-3" data-testid="chat-messages">
        {messages.map((m, i) => (
          <div key={i} className={`flex flex-col ${m.sender === "tech" ? "items-end" : "items-start"}`}>
            <span className="text-[10px] text-slate-500 mb-0.5">{m.name}</span>
            <p className={`text-sm rounded-lg px-3 py-2 max-w-[90%] break-words ${m.sender === "tech" ? "bg-sky-500 text-slate-950" : "bg-slate-800"}`}>{m.text}</p>
          </div>
        ))}
        {!messages.length && <p className="text-xs text-slate-500">Les messages s'affichent dans une fenêtre sur l'écran du client.</p>}
        <div ref={endRef} />
      </div>
      <form onSubmit={submit} className="p-3 border-t border-slate-800 flex gap-2">
        <Input data-testid="chat-input-field" value={text} onChange={(e) => setText(e.target.value)} placeholder="Votre message…" />
        <Button data-testid="chat-send-btn" type="submit" size="icon"><Send className="h-4 w-4" /></Button>
      </form>
    </aside>
  );
};
